import {
  requiredNumber,
  requiredString,
} from '@client/pages/CustomProgramPage/zod-helpers';
import { z } from 'zod';

export const defaults = {
  reps: {
    min: 1,
    max: 600,
    default: 10,
  },
  time: {
    min: 1,
    max: 3599,
    default: 40,
  },
  rest: {
    min: 0,
    max: 3599,
    default: 20,
  },
  rounds: {
    min: 1,
    max: 20,
    default: 1,
  },
  longRest: {
    min: 0,
    max: 1000,
    default: 0,
  },
  sets: {
    min: 1,
    max: 20,
    default: 1,
  },
};

const baseParentSchema = z.object({
  id: requiredString('id'),
  name: requiredString('Name'),
  description: requiredString('Description'),
  longRest: requiredNumber(
    'Long Rest',
    defaults.longRest.min,
    defaults.longRest.max,
  ),
});

export const tabataSchema = baseParentSchema.extend({
  rounds: requiredNumber('Rounds', defaults.rounds.min, defaults.rounds.max),
  // exercises: z.array(z.any()).min(1, 'At least one exercise required'),
});

export const hiitSchema = tabataSchema;

const baseSubExerciseSchema = z.object({
  id: requiredString('id'),
  name: requiredString('Title'),
  description: requiredString('Description'),
  media: z.any().optional().nullable(),
});

export const tabataExerciseSchema = baseSubExerciseSchema.extend({
  sets: z
    .array(
      z.object({
        rep: z.union([
          z.object({
            type: z.literal('fixed'),
            value: z.number().min(defaults.reps.min),
          }),
          z.object({ type: z.literal('AMRAP') }),
        ]),
        time: requiredNumber('Time', 1, defaults.time.max),
        rest: requiredNumber('Rest', 0, defaults.rest.max),
      }),
    )
    .min(1, 'At least one set required'),
});

export const hiitExerciseSchema = tabataExerciseSchema;
